import React from 'react';
import { Card, CardContent } from '@lb-service/ui';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import SectionIntro from '../../../molecules/SectionIntro';

const FreeConversationOverview = () => {
  const { t } = useTranslation('common');
  return (
    <Card>
      <CardContent>
        <div id="free-conversation-course-overview">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 mt-24">
            <SectionIntro
              title={t('service.courses.freeConversation.overview.title')}
              intro={t('service.courses.freeConversation.overview.intro')}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default FreeConversationOverview;
